// Load  more resources with AJAJ

jQuery(function ($) {
	setupLoadMore($);
});

function setupLoadMore($) {
	const loadMoreButton = $('.mithaiti-ajaj-loadmore');
	
	if (loadMoreButton.length) {
		
		loadMoreButton.click(function (e) {
			e.preventDefault();

			let obj = jQuery(this),
				parent = jQuery(this).parent();

			parent.addClass('loading');

			var params = {
				'nonce': loadmore_params.ajax_nonce,
				'query': loadmore_params.posts,
				'pages': loadmore_params.total_pages,
				'action': jQuery(this).data('action'),
				'page': parseInt(jQuery(this).data('page')) + 1
			}

			// Override default parameters with HTML data attributes
			if (typeof jQuery(this).data('params') == 'object') {
				jQuery.extend(params, jQuery(this).data('params'));
			}

			jQuery.ajax({
				url: loadmore_params.ajax_url,
				type: 'post',
				data: params,
				complete: function () {
					parent.removeClass('loading');
				},
				success: function (data) {
					parent.before(data);
					if (params.pages == params.page) {
						parent.remove();
					} else {
						obj.data('page', params.page);
					}
				}
			});
		});
	}
}

